import { LocationQuery } from "vue-router"
import { z } from "zod"
import { authorSchema } from "@/models/author"
import { doGetRequest, generateImagesList} from "@/lib/utils.ts"

export const articleSchema = z.object({
  id: z.number(),
  publication_id: z.number(),
  title: z.string(),
  language: z.string().nullable(),
  publication_year: z.number(),
  publication_number: z.string(),
  start_page: z.number(),
  end_page: z.number(),
  abstract_it: z.string().nullable().default(null),
  abstract_en: z.string().nullable().default(null),
  document_id: z.string(),
  blob_id: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
  authors: authorSchema.array().optional()
})

export type Article = z.infer<typeof articleSchema>

export const getArticles = async ({
  query,
  signal,
  paginate
}: {
  query: LocationQuery
  signal: AbortSignal,
  paginate: boolean
}): Promise<{
  data: Article[]
  pages: number
}> => {
  return doGetRequest("/api/articles", { signal, params: query }, (response:any) => {
    if (!paginate) {
      return response.data.map(articleSchema.parse)
    }

    return {
      data: response.data.items.map(articleSchema.parse),
      pages: response.data.pages
    }
  })
}

export const getArticle = async ({ id, signal }: { id: string | undefined; signal: AbortSignal }): Promise<Article> => {
  if (!id) throw new Error("Article ID is required")

  return doGetRequest(`/api/articles/${id}`, { signal }, (response:any) => {
    return articleSchema.parse(response.data)
  })
}

export type Attachment = z.infer<typeof attachmentSchema>
export const attachmentSchema = z.object({
  src: z.string(),
  w: z.number(),
  h: z.number()
})

export const getArticleAttachments = async ({
  documentId,
  articleId,
  publicationId,
  signal
}: {
  documentId: string | undefined | null
  articleId: string | undefined | null
  publicationId: number | undefined | null
  signal: AbortSignal
}): Promise<Attachment[]> => {
  if (!documentId) throw new Error("Document ID is required")

  return doGetRequest(`/zapdoc/api/documents/${documentId}/page_count`, { signal }, (response:any) => {

    doGetRequest('/api/update_stats/view', {
      signal,
      params: {
        type: 'article',
        article_id: articleId,
        publication_id: publicationId
      }
    })

    return generateImagesList(documentId, response.data)
  })
}